import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import Hamb from '../../images/hamburger.svg'
import Logo from '../../images/logo.svg'
const Header = (props, { siteTitle }) => {
    const navbar = props.header
    const [show, setShow] = useState(false)
    const [isNavOpened, setNavState] = useState(false)
    const handleClick = e => {
        e.preventDefault()
        setNavState(!isNavOpened)
        isNavOpened
            ? (document.body.style.overflow = `initial`)
            : (document.body.style.overflow = `hidden`)
        setShow(!show)
    }
    if (typeof window !== `undefined`) {
        useEffect(() => {
            document.body.style.overflow = `initial`
        }, [window.onpopstate])
    }
    return (
        <header>
            <div className="container">
                <div className="header">
                    <div className="logo">
                        <Link to="/">
                            <img src={Logo} alt="Jump" />
                        </Link>
                    </div>
                    <div className="header-nav">
                        <button className="header-nav__btn">
                            <div
                                id="hamburger"
                                className={!show ? `` : `open`}
                                onClick={e => handleClick(e)}
                            >
                                <span />
                                <span />
                                <span />
                                <span />
                            </div>
                        </button>
                        <div className="navbar-container">
                            <ul
                                className={
                                    show
                                        ? `header-nav-opened`
                                        : `header-nav-closed`
                                }
                            >
                                {navbar.map(item => {
                                    if (item.node.title !== `Blog`) {
                                        let adress = item.node.title.toLowerCase()
                                        adress = adress.replace(/ /g, `-`)
                                        return (
                                            <li className="nav-list">
                                                <Link to={adress}>
                                                    {item.node.title}
                                                </Link>
                                            </li>
                                        )
                                    } else {
                                        return (
                                            <li className="nav-list">
                                                <Link to="/">Blog</Link>
                                            </li>
                                        )
                                    }
                                })}
                                <li className="nav-list">
                                    <button className="btn">
                                        10x Your Revenue
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

Header.propTypes = {
    siteTitle: PropTypes.string,
}

Header.defaultProps = {
    siteTitle: ``,
}

export default Header
